import { AccountPageLayout, AccountDJVerification } from '@bpm-web-app/components';

export function AccountDJVerificationPage() {
    return (
        <AccountPageLayout>
            <AccountDJVerification />
        </AccountPageLayout>
    );
}
export default AccountDJVerificationPage;
